import { DecimalPipe, I18nPluralPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input, model } from '@angular/core';
import { MatHint } from '@angular/material/form-field';

import { IntegerFormControl, NumberFormRangeStrategy } from 'forms-data';
import { CartStepperInputComponent } from '../../../quantity-selector';
import { QuantityItemPriceModel } from 'products-data';

@Component({
  selector: 'ideal-cart-item-quantity-selector-view',
  imports: [CartStepperInputComponent, MatHint, I18nPluralPipe, DecimalPipe],
  standalone: true,
  templateUrl: './cart-item-quantity-selector-view.component.html',
  styleUrl: './cart-item-quantity-selector-view.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.updating]': 'isUpdating()',
  },
})
export class CartItemQuantitySelectorViewComponent {
  public readonly quantity = model<number>();
  public readonly pricing = input<QuantityItemPriceModel>();
  public readonly isUpdating = input<boolean>();
  /** When off, the multiples hints are not rendered. The subscript space stays reserved for validation/error messages. */
  public readonly sellMultipleHints = input(true);
  /** Short label for narrow containers. */
  public readonly compact = input(false);

  protected readonly soldInMultiplesOf = computed(() => this.pricing()?.pricingModel.quantitySoldIn ?? 1);
  protected readonly label = computed(() =>
    this.compact() ? $localize`:@@cart.quantity-label.short:Cart Qty` : $localize`:@@cart.quantity-label:Quantity in Cart`,
  );

  protected readonly control = new IntegerFormControl(null, {
    min: 0,
    max: 999999999,
    step: 1,
    rangeStrategy: NumberFormRangeStrategy.Restrict,
  });

  protected readonly displayUnitLabel = computed(() => {
    return this.pricing()?.pricingModel?.unitLabelLocalized ?? {};
  });
}
